import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FaHashtag, FaLink } from 'react-icons/fa'
import { CalendarPlus2, ClockArrowDown, Eye, MessageSquareDot, OctagonX, UserPlus, UserRoundPlus, Users, View } from 'lucide-react'
import { dashboardCount } from '../../redux/slice/Dashboard'
import { Link, useNavigate } from 'react-router-dom'
import Loader from '../../components/loader/Loader'
import '../../assets/css/Dashboard.css'
import moment from 'moment'

export default function Dashboard() {
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const dashboardData = useSelector(state => state?.dashboardCount?.data?.[0])

    useEffect(() => {
        setLoading(true)
        dispatch(dashboardCount({ navigate })).then((res) => list_res(res.payload))
    }, [])

    const list_res = (res) => {
        if (res?.status == 200) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    const formatDisplayDate = (date) => {
        if (!date || date === '-') return '-'
        const subscriptionDate = moment(date).locale('en').startOf('day')
        if (!subscriptionDate.isValid()) return '-'
        if (subscriptionDate.isBefore(moment().startOf('day'))) return '-'
        return subscriptionDate.format('DD-MMM-YYYY')
    }

    const renderSubscriptionStatus = (date) => {
        if (!date || date === '-') return '-'
        const subscriptionDate = moment(date).locale('en').startOf('day')
        if (!subscriptionDate.isValid()) return '-'
        const isActive = !subscriptionDate.isBefore(moment().startOf('day'))
        return (
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ display: 'inline-block', width: 10, height: 10, borderRadius: '50%', background: isActive ? '#22c55e' : '#ef4444' }}></span>
                <span>{subscriptionDate.format('DD-MMM-YYYY')}</span>
            </span>
        )
    }

    const StatCard = ({ title, value, icon, to, colorClass, activeKey }) => {
        const CardContent = (
            <div className={`dashboard_card ${colorClass}`}>
                <div className='card-content-wrapper'>
                    <div className='dashboard_icon_wrapper ms-3'>
                        {icon}
                    </div>
                    <div className='card-text-content'>
                        <h4>{title}</h4>
                        <h3>{value}</h3>
                    </div>
                </div>
            </div>
        )

        return to ? <Link to={to} state={{ activeKey }}>{CardContent}</Link> : CardContent
    }

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-md-12">
                    <div className='layout d-flex justify-content-between align-items-center'>
                        <h5>Dashboard Overview</h5>
                    </div>
                </div>

                {loading ? (
                    <div className="col-md-12 mt-3">
                        <div className=" layout text-center">
                            <Loader />
                        </div>
                    </div>
                ) : (
                    <div className='col-md-12 mt-3'>
                        <div className='row '>
                            <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                                <StatCard
                                    title="Subscription"
                                    value={renderSubscriptionStatus(dashboardData?.bioLinkSubscription)}
                                    icon={<CalendarPlus2 size={22} />}
                                    colorClass="card-theme-blue"
                                />
                            </div>

                            <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                                <StatCard
                                    title="Total Short Links"
                                    value={dashboardData?.totalShortLink || 0}
                                    icon={<FaLink size={20} />}
                                    to="/short-links"
                                    colorClass="card-theme-purple"
                                />
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                                <StatCard
                                    title="Total Followers"
                                    value={dashboardData?.totalFollower || 0}
                                    icon={<Users size={22} />}
                                    to="/connection-management"
                                    activeKey="followers"
                                    colorClass="card-theme-indigo"
                                />
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                                <StatCard
                                    title="Total Following"
                                    value={dashboardData?.totalFollowing || 0}
                                    icon={<UserPlus size={22} />}
                                    to="/connection-management"
                                    activeKey="following"
                                    colorClass="card-theme-green"
                                />
                            </div>



                            <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                                <StatCard
                                    title="Total Blocked"
                                    value={dashboardData?.totalBlocked || 0}
                                    icon={<OctagonX size={22} />}
                                    to="/connection-management"
                                    activeKey="blocked"
                                    colorClass="card-theme-red"
                                />
                            </div>

                            <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                                <StatCard
                                    title="Pending Requests"
                                    value={dashboardData?.totalPendingRequest || 0}
                                    icon={<ClockArrowDown size={22} />}
                                    to="/connection-management"
                                    activeKey="requests"
                                    colorClass="card-theme-orange"
                                />
                            </div>

                            <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                                <StatCard
                                    title="Unread Chats"
                                    value={dashboardData?.totalUnreadChat || 0}
                                    icon={<MessageSquareDot size={22} />}
                                    to="/chat-list"
                                    colorClass="card-theme-blue"
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div >
    )
}
